module.exports = __webpack_public_path__ + "assets/e00aaef2df87d226a6c06cdf7f6002a0.jpg";